import type { SelectHTMLAttributes } from "react";
import React from "react";

import Icon from "@atoms/Icon";

export interface IOption<T extends string | number> {
  name: string;
  value: T;
}

interface IProps<T extends string | number> extends SelectHTMLAttributes<HTMLSelectElement> {
  options: IOption<T>[];
}

export default function Select<T extends string | number>({ options, name, onChange, ...props }: IProps<T>) {
  return (
    <div className="relative mr-2 flex w-fit cursor-pointer items-center">
      <Icon className="absolute" height="35" name="SelectBorder" width="117" />
      <select
        className="darkmode font-fuzzy font-fuzzy-bold z-10 w-27 cursor-pointer items-center truncate rounded-full py-1.5 pr-10 pl-5 outline-hidden"
        key={name}
        name={name}
        onChange={onChange}
        {...props}
      >
        {options?.map((option) => (
          <option disabled={option.value === ""} key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
      <Icon className="pointer-events-none absolute right-3 dark:text-white" name="Select" width="11px" />
    </div>
  );
}
